import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';

import {
  getConfigurationModeOptions,
  getSelectedConfigurationMode,
} from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Selectors';
import { selectConfigurationMode } from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Actions';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import ConfigurationPicker from '../../Components/ConfigurationPicker';
import { setDesignerMobileProductListOpen, setDesignerMobileModalContent } from '../../../Reducers/CustomDesignReducer/Actions';
import { setCreatorMobileProductListOpen, setCreatorMobileModalContent } from '../../../Reducers/CustomCreatorReducer/Actions';

const mapStateToProps = (state) => {
  const configurationModeOptions = getConfigurationModeOptions(state);
  const selectedConfigurationMode = getSelectedConfigurationMode(state);
  console.log({configurationModeOptions})
  return {
    Component: ConfigurationPicker,
    selectedConfigurationMode,
    showConfigurationModeSwitch: configurationModeOptions.length > 0,
    configurationModeOptions,
    designerModalContentOptions: state.customDesignerData.designerMobileModalContentOptions,
    creatorModalContentOptions: state.customCreatorData.creatorMobileModalContentOptions,

  };
};

const mapDispatchToProps = (dispatch) => ({
  changeMode: async (mode) => {
    if (mode === 'designer' && getConf('validateBeforeCTA')) {
      await Services.configurator.validateConfiguration();
      if (Services.store.state.configurator.validation.success) {
        dispatch(selectConfigurationMode(mode));
      }
    } else {
      dispatch(selectConfigurationMode(mode));
    }
  },

  setDisplayDesignerMobilePicker: (value) => {
    dispatch(setDesignerMobileProductListOpen(!!value));
  },
  setDisplayCreatorMobilePicker: (value) => {
    dispatch(setCreatorMobileProductListOpen(!!value));
  },
  setDesignerModalContentOption: (value) => {
    dispatch(setDesignerMobileModalContent(value));
  },
  setCreatorModalContentOption: (value) => {
    dispatch(setCreatorMobileModalContent(value));
  },
});

export default containerConnect(mapStateToProps, mapDispatchToProps);

//
// selectedConfigurationMode
